import React, { useState, useEffect } from "react";

import axios from "axios";
import { BASE_URL, security_key } from "../../global";
const RecentActivity = () => {
    const [loading, setLoading] = useState(false);
    const [recentPost, setRecentPost] = useState([]);

    useEffect(() => {
        getAdminRecentPosts();
    }, []);

    const getAdminRecentPosts = async () => {
        try {
            setLoading(true);

            const response = await axios.post(`${BASE_URL}API/apicall`, {
                security_key,
                mode: "getAdminRecentPosts",
            });

            const output = response.data;
            if (output.length > 0) {
                setRecentPost(output);
            } else {
                console.error("Oops! Something went wrong.");
            }
        } catch (error) {
            console.error("Error adding article: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    const getTimeDifference = (row) => {
        if (row["MinuteDifference"] < 60) {
            return `${row["MinuteDifference"]} minute${row["MinuteDifference"] === 1 ? "" : "s"} ago`;
        }
        if (row["HourDifference"] < 24) {
            return `${row["HourDifference"]} hour${row["HourDifference"] === 1 ? "" : "s"} ago`;
        }
        if (row["DayDifference"] === 0 && row["HourDifference"] >= 24) {
            // If DayDifference is 0 but HourDifference is at least 24, it means it's within the same day
            return `${Math.floor(row["HourDifference"] / 24)} day${Math.floor(row["HourDifference"] / 24) === 1 ? "" : "s"} ago`;
        }
        return `${row["DayDifference"]} day${row["DayDifference"] === 1 ? "" : "s"} ago`;
    };
    return (
        <>
            <h5 className="mt-3 ms-3">Recent Posts</h5>
            <ul className="list-group ms-0">
                {recentPost.slice(0, 6).map((row, index) => {
                    if (row.type_no == 1) {
                        return (
                            <li key={index} className="list-group-item">
                                <strong>
                                    {row["first_name"]} {row["last_name"]}
                                </strong>{" "}
                                liked your post
                                <small className="text-muted float-end">{getTimeDifference(row)}</small>
                            </li>
                        );
                    } else if (row.type_no == 2) {
                        return (
                            <li key={index} className="list-group-item">
                                <strong>{row["com_name"]}</strong> commented on your video
                                <small className="text-muted float-end">{getTimeDifference(row)}</small>
                            </li>
                        );
                    } else if (row.type_no == 3) {
                        return (
                            <li key={index} className="list-group-item">
                                <strong>
                                    {row["first_name"]} {row["last_name"]}
                                </strong>{" "}
                                subscribed to paperboy
                                <small className="text-muted float-end">{getTimeDifference(row)}</small>
                            </li>
                        );
                    }
                })}
                {/* <li className="list-group-item">
                    <strong>John Doe</strong> subscribed to your channel
                    <small className="text-muted float-end">2 hours ago</small>
                </li>
                <li className="list-group-item">
                    <strong>Mary Johnson</strong> liked your post
                    <small className="text-muted float-end">5 hours ago</small>
                </li>
                <li className="list-group-item">
                    <strong>Jane Smith</strong> commented on your video
                    <small className="text-muted float-end">3 hours ago</small>
                </li>
                <li className="list-group-item">
                    <strong>Jane Smith</strong> commented on your video
                    <small className="text-muted float-end">3 hours ago</small>
                </li>
                <li className="list-group-item">
                    <strong>Mary Johnson</strong> liked your post
                    <small className="text-muted float-end">5 hours ago</small>
                </li>
                <li className="list-group-item">
                    <strong>John Doe</strong> subscribed to your channel
                    <small className="text-muted float-end">2 hours ago</small>
                </li> */}
            </ul>
        </>
    );
};

export default RecentActivity;
